"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KodenAddIcon = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Container = styled_components_1.default.svg `
	width: 32px;
	height: 32px;
	color: ${props => props.disabled ? "#7E7E7E" : "#79b256"};
	cursor: ${props => props.disabled ? "not-allowed" : "pointer"};
`;
const KodenAddIcon = ({ disabled = false, className = "", onClick, }) => {
    return (React.createElement(Container, { disabled: disabled, className: className, stroke: "currentColor", fill: "currentColor", strokeWidth: "0", viewBox: "0 0 512 512", xmlns: "http://www.w3.org/2000/svg", onClick: () => {
            if (!disabled && onClick) {
                onClick();
            }
        } },
        React.createElement("path", { d: "M256 48C141.125 48 48 141.125 48 256s93.125 208 208 208 208-93.125 208-208S370.875 48 256 48zm107 229h-86v86h-42v-86h-86v-42h86v-86h42v86h86v42z" })));
};
exports.KodenAddIcon = KodenAddIcon;
exports.default = exports.KodenAddIcon;
//# sourceMappingURL=koden-add-icon.js.map